import Main from '@/views/Main.vue'

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录',
  },
  component: () => import('@/views/login/login.vue'),
}
export const loginDemo = {
  path: '/demo',
  name: 'demo',
  meta: {
    title: 'Login - 体验',
  },
  component: () => import('@/views/demo/login.vue'),
}
export const logonRouter = {
  path: '/logon',
  name: 'logon',
  meta: {
    title: 'logon - 登录',
  },
  component: () => import('@/views/logon/logon.vue'),
}
export const oauthRouter = {
  path: '/oauth',
  name: 'oauth',
  meta: {
    title: 'oauth - 登录',
  },
  component: () => import('@/views/oauth/oauth.vue'),
}

export const checkDeviceRouter = {
  path: '/checkDevice',
  name: 'checkDevice',
  meta: {
    title: 'checkDevice - 登录设备校验',
  },
  component: () => import('@/views/check-device/checkDevice.vue'),
}

export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在',
  },
  component: () => import('@/views/error-page/404.vue'),
}

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足',
  },
  name: 'error-403',
  component: () => import('@/views/error-page/403.vue'),
}

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误',
  },
  name: 'error-500',
  component: () => import('@/views/error-page/500.vue'),
}

export const locking = {
  path: '/locking',
  name: 'locking',
  component: () => import('@/views/main-components/lockscreen/components/locking-page.vue'),
}

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/home',
  component: Main,
  children: [
    {
      path: 'identify',
      title: '消息中心',
      name: 'identify_index',
      component: () => import('@/views/security/identify/index.vue'),
    },
    {
      path: 'noticeDetail',
      title: '消息详情',
      name: 'noticeDetail',
      component: () => import('@/views/messageEnter/noticeDetail/index.vue'),
    },
  ],
}

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: '/index',
    name: 'index',
    title: '首页',
    icon: 'ios-home-outline',
    component: Main,
    children: [
      {
        path: 'index_home',
        title: '首页',
        name: 'index_home',
        icon: 'icon-pg-home',
        component: () => import('@/views/homePage/index.vue'),
      },
    ],
  },
  {
    path: '/profile',
    name: 'profile',
    title: '基本信息',
    icon: 'ios-person-outline',
    component: Main,
    children: [
      {
        path: 'profile_home',
        title: '基本信息',
        name: 'profile_home',
        icon: 'icon-pg-person',
        component: () => import('@/views/profile/index.vue'),
      },
    ],
  },
  {
    path: '/security',
    name: 'security',
    title: '安全中心',
    icon: 'ios-person-outline',
    component: Main,
    children: [
      {
        path: 'security_home',
        title: '安全中心',
        name: 'security_home',
        icon: 'icon-pg-security',
        component: () => import('@/views/security/index.vue'),
      },
    ],
  },
  // {
  //     path: '/enterprise',
  //     name: 'enterprise',
  //     title: '我的企业',
  //     icon: 'icon-pg-enterprise',
  //     component: Main,
  //     children: [{
  //         path: 'enterprise_home',
  //         title: '我的企业',
  //         name: 'enterprise_home',
  //         component: () =>
  //             import ('@/views/enterprise/index.vue')
  //     }, {
  //         path: 'enterprise_form',
  //         title: '基本信息',
  //         name: 'enterprise_form',
  //         component: () =>
  //             import ('@/views/enterprise/form/form.vue')
  //     }, {
  //         path: 'enterprise_testify',
  //         title: '基本信息',
  //         name: 'enterprise_testify',
  //         component: () =>
  //             import ('@/views/enterprise/testify/testify.vue')
  //     }]
  // },
  {
    path: '/messageEnter',
    name: 'messageEnter',
    title: '消息中心',
    icon: 'icon-pg-announcement',
    component: Main,
    children: [
      {
        path: 'messageEnter_home',
        title: '消息中心',
        name: 'messageEnter_home',
        component: () => import('@/views/messageEnter/index.vue'),
      },
    ],
  },
  {
    path: '/news',
    name: 'news',
    title: '公告中心',
    icon: 'icon-pg-notification',
    component: Main,
    children: [
      {
        path: 'news-query',
        title: '公告中心',
        name: 'news-query',
        component: () => import('@/views/news/index.vue'),
      },
      {
        path: 'news-detail',
        title: '公告中心',
        name: 'news-detail',
        component: () => import('@/views/news/detail.vue'),
      },
    ],
  },
  {
    path: '/standby',
    name: 'standby',
    title: '待办中心',
    icon: 'icon-pg-calendar',
    component: Main,
    children: [
      {
        path: 'standby_home',
        title: '待办中心',
        name: 'standby_home',
        component: () => import('@/views/standby/index.vue'),
      },
    ],
  },
  {
    path: '/wechat',
    name: 'wechat',
    title: '微信绑定',
    icon: 'icon-pg-wechat',
    component: Main,
    children: [
      {
        path: 'bind',
        title: '微信绑定',
        name: 'wechat-bind',
        component: () => import('@/views/wechat/index.vue'),
      },
    ],
  },
]

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  loginDemo,
  logonRouter,
  oauthRouter,
  checkDeviceRouter,
  otherRouter,
  locking,
  ...appRouter,
  page500,
  page403,
]
